import React from 'react';
import chroma from 'chroma-js';

import Graphic from '../Graphic';
import { useTheme } from '../../../hooks/index';

const Dashboard = props => {
  const { primary } = useTheme();

  return (
    <Graphic
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      viewBox="0 0 140 145"
      preserveAspectRatio="xMidYMid meet"
      fill="none"
      {...props}>
      <path
        fill="#F3F3F4"
        d="M70.997 145c28.166 0 51-1.567 51-3.5s-22.834-3.5-51-3.5c-28.167 0-51 1.567-51 3.5s22.833 3.5 51 3.5Z"
      />
      <path
        fill="#D9D9D9"
        d="M70.155 139.214c33.775 0 61.155-27.359 61.155-61.107S103.93 17 70.155 17C36.38 17 9 44.358 9 78.107c0 33.748 27.38 61.107 61.155 61.107Z"
      />
      <path
        fill={primary}
        fillOpacity=".5"
        d="M106.835 127.565C96.565 135.368 83.75 140 69.853 140c-14.326 0-27.501-4.922-37.925-13.166l23.684-23.665 25.132 25.112 13.404-13.393 12.687 12.677Z"
      />
      <path
        fill={primary}
        fillOpacity=".5"
        d="M102.323 130.685c-9.409 5.902-20.54 9.315-32.47 9.315-9.796 0-19.054-2.301-27.262-6.393l13.021-8.674 25.132 8.37 13.404-10.045 8.175 7.427Z"
      />
      <path
        fill={primary}
        fillOpacity=".75"
        fillRule="evenodd"
        d="M110.816 124.85c.28-.248.556-.497.83-.748a.498.498 0 0 0 .132-.54.504.504 0 0 0-.448-.328.486.486 0 0 0-.193.03.477.477 0 0 0-.167.101c-.54.495-1.089.981-1.646 1.457a.496.496 0 0 0-.186.343.491.491 0 0 0 .274.495.5.5 0 0 0 .561-.078c.283-.241.564-.485.843-.732Zm3.274-4.556a.5.5 0 0 0 .726.687 61.571 61.571 0 0 0 4.316-5.089.502.502 0 0 0-.096-.701.501.501 0 0 0-.701.096 60.844 60.844 0 0 1-4.245 5.007Zm-9.417 9.343a.507.507 0 0 0 .209-.321.49.49 0 0 0-.217-.511.517.517 0 0 0-.377-.071.51.51 0 0 0-.179.077 60.716 60.716 0 0 1-3.7 2.336.5.5 0 0 0-.159.671.502.502 0 0 0 .662.194 61.929 61.929 0 0 0 3.761-2.375Zm-5.706 3.46a.5.5 0 0 0-.471-.882c-18.15 9.695-39.99 9.416-57.775-.37a.502.502 0 0 0-.728.577.494.494 0 0 0 .246.299c18.079 9.947 40.277 10.232 58.728.376Zm24.138-25.146a.488.488 0 0 0-.043.38.497.497 0 0 0 .62.342.494.494 0 0 0 .299-.239c9.968-18.084 10.275-40.283.434-58.727a.502.502 0 0 0-.909.096.5.5 0 0 0 .027.374c9.679 18.144 9.379 39.983-.428 57.774Zm-.639-59.687a.503.503 0 0 0 .684.18.499.499 0 0 0 .181-.683 60.79 60.79 0 0 0-2.374-3.762.499.499 0 1 0-.825.564 60.686 60.686 0 0 1 2.334 3.7Zm-89.689 79.612a.501.501 0 0 0 .605-.797 60.52 60.52 0 0 1-5.008-4.244.504.504 0 0 0-.351-.117.504.504 0 0 0-.472.5.5.5 0 0 0 .136.344 61.512 61.512 0 0 0 5.09 4.314Zm-8.212-7.484a.508.508 0 0 0 .347.161.506.506 0 0 0 .36-.131.5.5 0 0 0 .03-.706 68.039 68.039 0 0 1-.7-.776C2.461 93.87 4.83 55.582 29.906 33.397c25.076-22.185 63.367-19.87 85.551 5.16.232.263.46.526.686.79a.5.5 0 0 0 .761-.65c-.219-.255-.44-.51-.662-.762l-.036-.04-.035-.04a62.576 62.576 0 0 0-3.805-3.926.57.57 0 0 0-.064-.073 61.517 61.517 0 0 0-5.091-4.314.495.495 0 0 0-.128-.071 61.164 61.164 0 0 0-7.187-4.653.493.493 0 0 0-.146-.12c-18.079-9.95-40.277-10.234-58.728-.377a.498.498 0 0 0-.22.237c-.472.255-.94.516-1.407.785a.498.498 0 0 0-.318.063 61.567 61.567 0 0 0-3.762 2.375.498.498 0 0 0-.194.262 62.18 62.18 0 0 0-4.8 3.673.497.497 0 0 0-.306.12c-.566.483-1.123.977-1.672 1.48a.498.498 0 0 0-.156.288 62.411 62.411 0 0 0-2.724 2.682.498.498 0 0 0-.29.15 61.643 61.643 0 0 0-4.316 5.09.497.497 0 0 0-.102.308 61.232 61.232 0 0 0-4.513 6.935.498.498 0 0 0-.234.215C6.04 67.068 5.733 89.266 15.574 107.71c.026.048.058.09.095.125.302.565.614 1.127.935 1.684.01.047.029.093.054.136a61.556 61.556 0 0 0 2.373 3.763.488.488 0 0 0 .076.087 62.06 62.06 0 0 0 4.71 6.056l.036.04.043.048c.221.25.443.497.669.742Z"
        clipRule="evenodd"
      />
      <path fill="#fff" d="M1.497 16.5h88v85h-88v-85Z" />
      <path stroke={primary} d="M1 16h88v85H1V16Z" />
      <path fill="#fff" d="M5.997 21h79v76h-79V21Z" />
      <path
        fill="#D9D9D9"
        d="M19.997 21h-13a1 1 0 0 0-1 1v74a1 1 0 0 0 1 1h13a1 1 0 0 0 1-1V22a1 1 0 0 0-1-1ZM40.906 30.048H26.747a1 1 0 0 0-1 1v10.667a1 1 0 0 0 1 1h14.159a1 1 0 0 0 1-1V31.048a1 1 0 0 0-1-1ZM62.45 30.048H48.293a1 1 0 0 0-1 1v10.667a1 1 0 0 0 1 1H62.45a1 1 0 0 0 1-1V31.048a1 1 0 0 0-1-1ZM83.997 30.048h-14.16a1 1 0 0 0-1 1v10.667a1 1 0 0 0 1 1h14.16a1 1 0 0 0 1-1V31.048a1 1 0 0 0-1-1ZM40.906 48.143H26.747a1 1 0 0 0-1 1V59.81a1 1 0 0 0 1 1h14.159a1 1 0 0 0 1-1V49.143a1 1 0 0 0-1-1ZM62.45 48.143H48.293a1 1 0 0 0-1 1V59.81a1 1 0 0 0 1 1H62.45a1 1 0 0 0 1-1V49.143a1 1 0 0 0-1-1ZM83.997 48.143h-14.16a1 1 0 0 0-1 1V59.81a1 1 0 0 0 1 1h14.16a1 1 0 0 0 1-1V49.143a1 1 0 0 0-1-1ZM40.906 66.238H26.747a1 1 0 0 0-1 1v10.667a1 1 0 0 0 1 1h14.159a1 1 0 0 0 1-1V67.238a1 1 0 0 0-1-1ZM62.45 66.238H48.293a1 1 0 0 0-1 1v10.667a1 1 0 0 0 1 1H62.45a1 1 0 0 0 1-1V67.238a1 1 0 0 0-1-1ZM83.997 66.238h-14.16a1 1 0 0 0-1 1v10.667a1 1 0 0 0 1 1h14.16a1 1 0 0 0 1-1V67.238a1 1 0 0 0-1-1ZM40.906 84.333H26.747a1 1 0 0 0-1 1V96a1 1 0 0 0 1 1h14.159a1 1 0 0 0 1-1V85.333a1 1 0 0 0-1-1ZM62.45 84.333H48.293a1 1 0 0 0-1 1V96a1 1 0 0 0 1 1H62.45a1 1 0 0 0 1-1V85.333a1 1 0 0 0-1-1ZM83.997 84.333h-14.16a1 1 0 0 0-1 1V96a1 1 0 0 0 1 1h14.16a1 1 0 0 0 1-1V85.333a1 1 0 0 0-1-1ZM39.206 21H26.652a.905.905 0 0 0 0 1.81h12.554a.905.905 0 1 0 0-1.81Z"
      />
      <path
        fill={primary}
        d="M84.092 21H78.72a.905.905 0 0 0 0 1.81h5.372a.905.905 0 1 0 0-1.81Z"
      />
      <path
        fill="#F3F3F4"
        d="M75.115 21h-5.372a.905.905 0 0 0 0 1.81h5.372a.905.905 0 1 0 0-1.81Z"
      />
      <path
        fill="#D9D9D9"
        d="M33.819 24.619h-7.167a.905.905 0 0 0 0 1.81h7.167a.905.905 0 1 0 0-1.81Z"
      />
      <path
        fill={primary}
        d="M100.336 46.418a23.473 23.473 0 0 0 15.781-.863 23.43 23.43 0 0 0 5.682-39.804 23.47 23.47 0 0 0-29.761.166 23.425 23.425 0 0 0-5.643 29.199l20.624-11.164-6.683 22.466Z"
      />
      <path
        fill="#fff"
        d="M125.305 9.271a23.468 23.468 0 0 0-39.863 5.487 23.422 23.422 0 0 0-.938 15.765 23.439 23.439 0 0 0 9.282 12.78 23.47 23.47 0 0 0 29.647-2.607 23.433 23.433 0 0 0 6.905-14.206l-23.319-2.538 18.286-14.681Z"
      />
      <path
        fill={primary}
        fillOpacity=".25"
        d="M125.305 9.271a23.468 23.468 0 0 0-39.863 5.487 23.422 23.422 0 0 0-.938 15.765 23.439 23.439 0 0 0 9.282 12.78 23.47 23.47 0 0 0 29.647-2.607 23.433 23.433 0 0 0 6.905-14.206l-23.319-2.538 18.286-14.681Z"
      />
      <path
        fill="#fff"
        d="M125.305 9.271a23.468 23.468 0 0 0-39.863 5.487 23.422 23.422 0 0 0-.938 15.765 23.439 23.439 0 0 0 9.282 12.78 23.47 23.47 0 0 0 29.647-2.607 23.433 23.433 0 0 0 6.905-14.206l-23.319-2.538 18.286-14.681Z"
      />
      <path
        fill={primary}
        fillOpacity=".25"
        d="M125.305 9.271a23.468 23.468 0 0 0-39.863 5.487 23.422 23.422 0 0 0-.938 15.765 23.439 23.439 0 0 0 9.282 12.78 23.47 23.47 0 0 0 29.647-2.607 23.433 23.433 0 0 0 6.905-14.206l-23.319-2.538 18.286-14.681Z"
      />
      <path
        stroke={primary}
        d="M125.305 9.271a23.468 23.468 0 0 0-39.863 5.487 23.422 23.422 0 0 0-.938 15.765 23.439 23.439 0 0 0 9.282 12.78 23.47 23.47 0 0 0 29.647-2.607 23.433 23.433 0 0 0 6.905-14.206l-23.319-2.538 18.286-14.681Z"
      />
      <path
        fill="#fff"
        d="M89.114 113.213c7.403 0 13.404-5.996 13.404-13.393s-6.001-13.393-13.404-13.393S75.71 92.423 75.71 99.82s6.001 13.393 13.404 13.393Z"
      />
      <path
        fill="url(#a)"
        fillRule="evenodd"
        d="M89.113 113.217c7.403 0 13.404-5.997 13.404-13.394S96.516 86.43 89.113 86.43c-7.402 0-13.403 5.996-13.403 13.393s6 13.394 13.403 13.394Zm1.676-18.416a1.676 1.676 0 0 0-3.351 0v3.348h-3.351a1.675 1.675 0 1 0 0 3.348h3.351v3.349a1.676 1.676 0 0 0 3.351 0v-3.349h3.351a1.674 1.674 0 1 0 0-3.348h-3.351v-3.348Z"
        clipRule="evenodd"
      />
      <path
        fill="#fff"
        d="M136.997 69.5h-13a1.5 1.5 0 0 0-1.5 1.5v13a1.5 1.5 0 0 0 1.5 1.5h13a1.5 1.5 0 0 0 1.5-1.5V71a1.5 1.5 0 0 0-1.5-1.5Z"
      />
      <path
        stroke={primary}
        d="M136.997 69.5h-13a1.5 1.5 0 0 0-1.5 1.5v13a1.5 1.5 0 0 0 1.5 1.5h13a1.5 1.5 0 0 0 1.5-1.5V71a1.5 1.5 0 0 0-1.5-1.5Z"
      />
      <path
        fill={primary}
        d="M126.097 78.1c0-.331.246-.6.55-.6h1.1c.304 0 .55.269.55.6v3c0 .331-.246.6-.55.6h-1.1c-.304 0-.55-.269-.55-.6v-3Zm3.3-2.4c0-.331.246-.6.55-.6h1.1c.304 0 .55.269.55.6v5.4c0 .331-.246.6-.55.6h-1.1c-.304 0-.55-.269-.55-.6v-5.4Zm3.3-1.8c0-.331.246-.6.55-.6h1.1c.304 0 .55.269.55.6v7.2c0 .331-.246.6-.55.6h-1.1c-.304 0-.55-.269-.55-.6v-7.2Z"
      />
      <defs>
        <linearGradient
          id="a"
          x1="89.114"
          x2="89.114"
          y1="86.43"
          y2="113.217"
          gradientUnits="userSpaceOnUse">
          <stop stopColor={chroma(primary).brighten(0.5 - 0)} />
          <stop offset="1" stopColor={primary} />
        </linearGradient>
      </defs>
    </Graphic>
  );
};
export default Dashboard;
